/**
 * Reads the backend-persisted terminal processing contract. A missing numeric
 * value is not enough to establish a safe failure: only an explicit suppressed
 * metric state (or a failed stage that names the metric) may stop the UI from
 * showing its short "Calculating…" state.
 */

function isObject(value) {
  return value != null && typeof value === "object" && !Array.isArray(value);
}

function outcomeEntries(data) {
  const outcomes = data?.results?.processingOutcomes;
  return isObject(outcomes) ? Object.values(outcomes).filter(isObject) : [];
}

export function getMetricProcessingState(data, metric) {
  for (const outcome of outcomeEntries(data)) {
    const metricState = outcome?.metricStates?.[metric];
    if (isObject(metricState) && metricState.presentation === "suppressed") {
      return metricState;
    }
    if (
      outcome.status === "failed" &&
      Array.isArray(outcome.affectedMetrics) &&
      outcome.affectedMetrics.includes(metric)
    ) {
      return {
        state: "processing_failed",
        presentation: "suppressed",
        reasonCode: outcome.reasonCode || "processing_failed",
      };
    }
  }

  // Existing heartDx records pre-date processingOutcomes. Keep their terminal
  // not-processed status safe until they are naturally superseded by reprocesses.
  if (
    metric === "hr" &&
    data?.results?.heartdx?.data?.processingStatus === "not_processed"
  ) {
    return {
      state: "processing_failed",
      presentation: "suppressed",
      reasonCode: data.results.heartdx.data.statusReason || "processing_failed",
    };
  }
  return null;
}

export function getSuppressedMetricKeys(data, metrics) {
  return metrics.filter((metric) => getMetricProcessingState(data, metric) != null);
}

export function hasTerminalProcessingFailure(data) {
  return outcomeEntries(data).some((outcome) => outcome.status === "failed");
}
